import insightMiddleware from "./middleware";
import insightReducers from "./reducers";

export { insightMiddleware };

export default insightReducers;
